import {mapGetters, mapMutations} from "vuex";
// import {getWebContentManagement, getGameService, getUserInfo} from "@/api";
import request from '@/http/request'

let mixin = {
    data() {
        return {
            btnDisabled: false,
            pagingPageSize: 10,
            totalPages: 0,
            currentPages: 1,
            info: {},
            datumList: [],
            hasMore: false,
            emptyText1: '暂无相关数据~',
        }
    },
    created() {
    },
    filters: {
        formatDate(dateTime = null, formatStr = 'yyyy-mm-dd') {
            let date
            // 若传入时间为假值，则取当前时间
            if (!dateTime) {
                date = new Date()
            }
            // 若为unix秒时间戳，则转为毫秒时间戳（逻辑有点奇怪，但不敢改，以保证历史兼容）
            else if (/^\d{10}$/.test(dateTime?.toString().trim())) {
                date = new Date(dateTime * 1000)
            }
            // 若用户传入字符串格式时间戳，new Date无法解析，需做兼容
            else if (typeof dateTime === 'string' && /^\d+$/.test(dateTime.trim())) {
                date = new Date(Number(dateTime))
            }
                // 处理平台性差异，在Safari/Webkit中，new Date仅支持/作为分割符的字符串时间
            // 处理 '2022-07-10 01:02:03'，跳过 '2022-07-10T01:02:03'
            else if (typeof dateTime === 'string' && dateTime.includes('-') && !dateTime.includes('T')) {
                date = new Date(dateTime.replace(/-/g, '/'))
            }
            // 其他都认为符合 RFC 2822 规范
            else {
                date = new Date(dateTime)
            }

            const timeSource = {
                'y': date.getFullYear().toString(), // 年
                'm': (date.getMonth() + 1).toString().padStart(2, '0'), // 月
                'd': date.getDate().toString().padStart(2, '0'), // 日
                'h': date.getHours().toString().padStart(2, '0'), // 时
                'M': date.getMinutes().toString().padStart(2, '0'), // 分
                's': date.getSeconds().toString().padStart(2, '0') // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            }

            for (const key in timeSource) {
                const [ret] = new RegExp(`${key}+`).exec(formatStr) || []
                if (ret) {
                    // 年可能只需展示两位
                    const beginIndex = key === 'y' && ret.length === 2 ? 2 : 0
                    formatStr = formatStr.replace(ret, timeSource[key].slice(beginIndex))
                }
            }

            return formatStr
        },
        timeFrom(timestamp = null, format = 'yyyy-mm-dd') {
            if (timestamp == null) timestamp = Number(new Date())
            timestamp = parseInt(timestamp)
            // 判断用户输入的时间戳是秒还是毫秒,一般前端js获取的时间戳是毫秒(13位),后端传过来的为秒(10位)
            if (timestamp.toString().length == 10) timestamp *= 1000
            let timer = (new Date()).getTime() - timestamp
            timer = parseInt(timer / 1000)
            // 如果小于5分钟,则返回"刚刚",其他以此类推
            let tips = ''
            switch (true) {
                case timer < 300:
                    tips = '刚刚'
                    break
                case timer >= 300 && timer < 3600:
                    tips = `${parseInt(timer / 60)}分钟前`
                    break
                case timer >= 3600 && timer < 86400:
                    tips = `${parseInt(timer / 3600)}小时前`
                    break
                case timer >= 86400 && timer < 2592000:
                    tips = `${parseInt(timer / 86400)}天前`
                    break
                default:
                    // 如果format为false，则无论什么时间戳，都显示xx之前
                    if (format === false) {
                        if (timer >= 2592000 && timer < 365 * 86400) {
                            tips = `${parseInt(timer / (86400 * 30))}个月前`
                        } else {
                            tips = `${parseInt(timer / (86400 * 365))}年前`
                        }
                    } else {
                        tips = this.formatDate(timestamp, format)
                    }
            }
            return tips
        },
        priceFormat(number, decimals = 0, decimalPoint = '.', thousandsSeparator = ',') {
            number = (`${number}`).replace(/[^0-9+-Ee.]/g, '')
            const n = !isFinite(+number) ? 0 : +number
            const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
            const sep = (typeof thousandsSeparator === 'undefined') ? ',' : thousandsSeparator
            const dec = (typeof decimalPoint === 'undefined') ? '.' : decimalPoint
            let s = ''

            s = (prec ? Math.round(n, prec) + '' : `${Math.round(n)}`).split('.')
            const re = /(-?\d+)(\d{3})/
            while (re.test(s[0])) {
                s[0] = s[0].replace(re, `$1${sep}$2`)
            }

            if ((s[1] || '').length < prec) {
                s[1] = s[1] || ''
                s[1] += new Array(prec - s[1].length + 1).join('0')
            }
            return s.join(dec)
        }
    },
    computed: {
        ...mapGetters(["isLogin", "getUserId", "getUserToken", "getHeaderTitleIndex", "getGameRecentlyViewed"]),
        ...mapGetters({
            userInfo: "getUser"
        })
    },
    methods: {
        ...mapMutations(["setUserId", "setUserToken", "setUser", "setHeaderTitleIndex", "setGameRecentlyViewed"]),
        getUserInfo(callback) {
            let userId = this.getUserId;
            if (!userId) return
            // getUserInfo({}).then(res=>{
            //     let data = res.data
            //     if (data.code === 200) {
            //         this.user = data.data
            //         callback && callback(data.data)
            //     } else {
            //         this.$message.error(data.msg)
            //     }
            // })
        },
        // 回首页
        backHome() {
            this.$router.push({path: "/index"});
        },
        //返回上一页
        routerBack() {
            this.$router.back()
        },
        // 跳转
        toPage(path, needLogin = false) {
            if (needLogin && !this.isLogin) {
                this.toPage(`/login`)
                return;
            }
            if (path) {
                this.$router.push({path})
            }
        },
        getFullUrl1(url) {
            if (!url) return ''
            if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) return url
            let baseUrl = request.defaults.baseURL
            baseUrl = baseUrl.substring(0, baseUrl.length - 1)
            return `${baseUrl}${url}`;
        },
        // 打开新窗口
        openWindow(url) {
            window.open(url, '_blank');
        },
        //退出登录
        logout() {
            this.setUserId('')
            this.setUserToken('')
            this.setUser({})
            // localStorage.removeItem('userId')
            // localStorage.removeItem('userToken')
            this.$router.push({
                path: '/index',
                replace: true
            })
        },
        async handleCopy(val) {
            if (!val) return this.$message.error('没有需要复制的内容')
            if (navigator.clipboard && navigator.permissions) {
                await navigator.clipboard.writeText(val)
                this.$message.success('复制成功~')
            } else {
                const textArea = document.createElement('textArea')
                textArea.value = val
                textArea.style.width = 0
                textArea.style.position = 'fixed'
                textArea.style.left = '-999px'
                textArea.style.top = '10px'
                textArea.setAttribute('readonly', 'readonly')
                document.body.appendChild(textArea)

                textArea.select()
                document.execCommand('copy')
                document.body.removeChild(textArea)
                this.$message.success('复制成功~')
            }
        },
        formatDecimal(value, decimal = 2) {
            if (!value) return 0;
            const num = parseFloat(value);
            // 判断是否是有效数字
            if (isNaN(num)) return value;
            // 如果是整数，则直接返回原值
            if (Number.isInteger(num)) return num.toString()
            return num.toFixed(decimal);
        },
        maskMiddle(value, hideCount = 4) {
            if (value == null) return '';
            const str = String(value);
            const len = str.length;
            if (hideCount <= 0 || hideCount >= len) return '*'.repeat(len);
            const left = Math.floor((len - hideCount) / 2);
            const right = len - hideCount - left;
            return str.slice(0, left) + '*'.repeat(hideCount) + str.slice(len - right);
        },
        /**
         * @description 深度克隆
         * @param {object} obj 需要深度克隆的对象
         * @param cache 缓存
         * @returns {*} 克隆后的对象或者原值（不是对象）
         */
        deepClone(obj, cache = new WeakMap()) {
            if (obj === null || typeof obj !== 'object') return obj;
            if (cache.has(obj)) return cache.get(obj);
            let clone;
            if (obj instanceof Date) {
                clone = new Date(obj.getTime());
            } else if (obj instanceof RegExp) {
                clone = new RegExp(obj);
            } else if (obj instanceof Map) {
                clone = new Map(Array.from(obj, ([key, value]) => [key, this.deepClone(value, cache)]));
            } else if (obj instanceof Set) {
                clone = new Set(Array.from(obj, value => this.deepClone(value, cache)));
            } else if (Array.isArray(obj)) {
                clone = obj.map(value => this.deepClone(value, cache));
            } else if (Object.prototype.toString.call(obj) === '[object Object]') {
                clone = Object.create(Object.getPrototypeOf(obj));
                cache.set(obj, clone);
                for (const [key, value] of Object.entries(obj)) {
                    clone[key] = this.deepClone(value, cache);
                }
            } else {
                clone = Object.assign({}, obj);
            }
            cache.set(obj, clone);
            return clone;
        },
    }
}
export default mixin
